/* eslint-disable */
import _ from 'underscore';
import axios from 'axios';

import {
    apiUrl,
} from '../config';

import {
    refreshAccessToken,
    getAccessTokenSelector,
} from '../commons/reduxModules/Authentication';

function getRangeFromContentRange(contentRange) {
    const range = contentRange.split('/');
    return range[0];
}

export function configureAxios() {
    const auth = {
        baseURL: apiUrl,
        responseType: 'json',
    };

    return axios.create(auth);
}

export function configureAxiosOptions() {
    const clientOptions = {
        interceptors: {
            response: [(r, responseParam) => {
                let response = responseParam;
                response = _.extend(response, {
                    receivedAt: Date.now(),
                });

                if (!response.data) {
                    return response;
                }
                try {
                    if (_.isArray(response.data.results) && !_.isUndefined(response.data.paging)) {
                        response = _.extend(response, {
                            cursors: (response.data.paging) ? response.data.paging.cursors : null,
                            nbPerPage: response.data.paging.nb_per_page,
                            totalItems: response.data.paging.total,
                            range: getRangeFromContentRange(response.headers['content-range']),
                        });

                        // TODO : Il faut mettre a jour le Pager sur l'objet paging et pas sur "data" global (dont on se sert juste au dessus)
                        response = _.extend(response, {
                            data: _.extend(response.data, {
                                paging: _.extend(response.data.paging, {
                                    range: getRangeFromContentRange(response.headers['content-range']),
                                    nbPerPage: response.data.paging.nb_per_page,
                                    totalItems: response.data.paging.total,
                                }),
                            }),
                        });
                    }
                } catch (ex) {
                    console.log('call :', ex);
                }
                return response;
            }],
            request: [({getState, dispatch, getSourceAction}, req) => {
                const state = getState();
                let accessToken = window.YP_API && window.YP_API.ACCESS_TOKEN ? window.YP_API.ACCESS_TOKEN : '';
                if (state.Authentication) {
                    accessToken = getAccessTokenSelector(state);
                }
                req.headers = Object.assign({}, req.headers, {
                    Authorization: `Bearer ${accessToken}`,
                });
                return Promise.resolve(req);
            }],
        },
        onSuccess: ({
            action, next, response, getState,
        }) => {
            let responseCpy = response;
            // Ugly and legacy code required for the seating chart and dashboard apps
            if (action.type && action.payload.reducers) {
                const state = getState();

                if (state[action.payload.reducers]) {
                    state[action.payload.reducers].isLoading = false;
                }
                responseCpy = _.extend(responseCpy, {
                    reducers: action.payload.reducers,
                });
            }
            if (action.payload.request.onSuccess) {
                action.payload.request.onSuccess(responseCpy);
            }
            responseCpy.extras = action.payload.extras;

            next({
                type: `${action.type}_SUCCESS`,
                payload: responseCpy,
            });
        },
        onError: ({
            action, next, error, getState, dispatch,
        }) => {
            const errorCpy = error;
            if (errorCpy && errorCpy.response && errorCpy.response.data
             && errorCpy.response.data.status === 401
             && errorCpy.response.data.error_code === 'invalid_token') {
                return dispatch(refreshAccessToken(action.payload));
            }

            errorCpy.extras = action.payload.extras;

            next({
                type: `${action.type}_ERROR`,
                payload: errorCpy,
            });
        },
    };

    return clientOptions;
}
